import React from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import config from '../config.js'

import {fetchDataIfReady, fetchDataIfUndefined, clearStateBlock} from 'Skelet/src/modules/fetch.action.js'
import {openModal, closeModal} from 'Skelet/src/modules/functions.js'
import ModalCreateWork from './ModalCreateWork.js'
import refresh_icon from './28406.svg';
import icon_trash from './icon-trash.svg';


class WorkExperience extends React.Component {

  constructor(props) {
    super(props);

    this.state = {modal_open:false, modal_create_open:false};
  }

  componentWillMount() {
    if(this.props.session_token) {
      this.props.fetchDataIfReady(config.api_token, "work-index", "GET", config.api_url+"/work-index?t="+this.props.session_token);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.session_token) {
      this.props.fetchDataIfUndefined(config.api_token, "work-index", "GET", config.api_url+"/work-index?t="+nextProps.session_token);
    }
  }

  render() {
    let cards = "", end_of_list_text = "", page_cards = this.props.apiData["work-index"];
    if(page_cards !== undefined) {
      cards = page_cards.data.map(function(item, i) {
        return <div key={i}>
          <div className="card polls card-layout">
            <div className="card-layout-div85">{item.role}{item.company && <span> @ {item.company}</span>}</div>
            <div className="card-layout-div15 btn-detail">
              <div style={{textAlign:"right"}}>
                <button className="btn" onClick={() => this.handleDeletePrompt(item.id)}><img src={icon_trash} alt="Delete"/></button>
                <div id={"delete-prompt-"+item.id} style={{display:"none", marginTop:"7px"}}>
                  <span style={{marginRight:"14px"}}>Are you sure?</span>
                  <button className="btn" onClick={() => this.handleDelete(item.id)}>yes</button>
                </div>
              </div>
            </div>
          </div>
        </div>;
      }.bind(this));
    }

    if(page_cards === undefined || page_cards.isFetching) {
      end_of_list_text = "Loading..";
    } else if((page_cards !== undefined && !page_cards.isFetching)) {
      if(page_cards.data[0] !== undefined) {
        end_of_list_text = "End of results.";
      } else {
        end_of_list_text = "No results.";
      }
    }

    return (
      <div className="container content">
        <div className="card-layout">
          <div className="card-layout-div50"><strong>Work Experience</strong></div>
          <div className="card-layout-div50 index-actions">
            <button className="btn" style={{marginRight:"10px"}} onClick={() => openModal(this, null, null, "modal_create_open")}>Create</button>
            <img src={refresh_icon} alt="refresh" onClick={() => this.refresh()}/>
          </div>
        </div>
        {cards}
        <div className="end_of_list_text">{end_of_list_text}</div>
        <ModalCreateWork shouldShow={this.state.modal_create_open} close={() => closeModal(this, "modal_create_open")} />
      </div>
    );
  }

  refresh() {
    this.props.clearStateBlock("work-index");
  }

  handleDeletePrompt(id) {
    var prompt = document.getElementById("delete-prompt-"+id);
    prompt.style.display = "block";
  }

  handleDelete(id) {
    this.props.fetchDataIfReady(config.api_token, "bin", "DELETE", config.api_url+"/work-delete?t="+this.props.session_token, JSON.stringify({id}), null, true, false, false, false, false, null, "work-index");
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
    clearStateBlock,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkExperience)



// WEBPACK FOOTER //
// ./src/containers/WorkExperience.js